import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox", "visible", "invisible" ]

  connect() {
    this.changed()
  }

  changed() {
    const checked = this.currentCheckbox?.checked

    this.visibleTargets.forEach((element) => {
      element.hidden = !checked
    })
    this.invisibleTargets.forEach((element) => {
      element.hidden = checked
    })
  }

  get currentCheckbox() {
    return this.checkboxTargets.find((element) => element.type === "checkbox") || this.checkboxTargets[0]
  }

}
